var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"about_header"},[_c('h2',{staticClass:"text-capitalize white--text",style:(_vm.$vuetify.rtl ? {right: '10%'} :{left:'10%'})},[_vm._v(_vm._s(_vm.$t("aboutUs.about")))]),_c('div',{staticClass:"overlay"})])}
var staticRenderFns = []

export { render, staticRenderFns }